import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindCornerMarqueContent($cornerFilter: String!, $dressFilter: String!)
{
  queryCornerMarqueContents(top: 1, skip: 0, filter: $cornerFilter, search: null) {
    data {
      pageTitle {
        iv
      }
      link {
        iv
      }
      brandId{
        iv
      }
      picture {
        iv {
          url
          fileSize
        }
      }
      titleBlocTitle {
        iv
      }
      titleBlocSubTitle {
        iv
      }
      titleBlocFontSizeTitle {
        iv
      }
      titleBlocFontSizeSubTitle {
        iv
      }
      titleBlocTagline {
        iv
      }
      titleBlocColor {
        iv
      }
      titleBlocCtaLink {
        iv
      }
      titleBlocCtaText {
        iv
      }
      titleBlocCtaStyle {
        iv
      }
      titleBlocCtaLink2 {
        iv
      }
      titleBlocCtaText2 {
        iv
      }
      titleBlocCtaStyle2 {
        iv
      }
      titleBlocPicture {
        iv {
          url
        }
      }
      titleBlocTextColor {
        iv
      }
      titleBlocHorizontalPosition {
        iv
      }
      titleBlocJustification {
        iv
      }
      visuels {
        iv {
          title
          subTitle
          color
          link
          fontSizeSubTitle
          fontSizeTitle
          picture {
              url
              fileSize
          }
          textColor
          justification
        }
      }

      mentionLabel {
        iv
      }
      title {
        iv
      }
      titleFontSize {
        iv
      }
      titleTextColor {
        iv
      }
      description {
        iv
      }
      descriptionFontSize {
        iv
      }
      descriptionTextColor {
        iv
      }
      showroom {
        iv{id}
      }
    }
  }
  models: queryFicheProduitRobeContents(top: 1000, skip: 0, filter: $dressFilter, search: null) {
    id
    data {
      pageTitle {
        iv
      }
      thumbTitle {
        iv
      }
      thumbSubTitle {
        iv
      }
      thumbImage {
        iv {
          url
          fileSize
        }
      }
      type{
        iv
      }
      longueur{
        iv
      }
      manches{
        iv
      }
      matiere{
        iv
      }
      coupes{
        iv
      }
      decollete{
        iv
      }
      brandId{
        iv
      }
      productPrice{
        iv
      }
    }
  }
}
`,
]);
